/**
 * Normalise a Server ID string to Age of Empires Mobile's E##/E### format.
 * Rules (from owner):
 *   "5"      → "E05"
 *   "05"     → "E05"
 *   "e5"     → "E05"
 *   "E5"     → "E05"
 *   "E05"    → "E05"
 *   "10"     → "E10"
 *   "175"    → "E175"
 *   ""       → ""   (empty stays empty so users can clear the field)
 *   "abc"    → ""   (non-digit rubbish strips clean)
 * Pure function — no React or DOM dependencies so it's cheap to unit-test.
 */
export function normaliseServerId(raw) {
  const digits = String(raw ?? "").replace(/[^0-9]/g, "");
  if (!digits) return "";
  const n = parseInt(digits, 10);
  return n < 10 ? `E0${n}` : `E${n}`;
}
